<div class="my-modal">
    <div>
        <h4 class="titleModal">{{message | translate}}</h4>
    </div>
    @if (isConfirmDialog) {
      <div class="btnModal">
        <button class="mini-button annulla" (click)="close()">{{'no'| translate}}</button>
        <button class="mini-button conferma" (click)="save()">{{'yes' | translate}}</button>
      </div>
    } @else {
      <div class="btnModal">
        <button class="mini-button single" (click)="close()">OK</button>
      </div>
    }


</div>
